module.exports = __webpack_public_path__ + "assets/pooled-81ae1f.svg";